import { useEffect, useState } from "react";

/** False on server and first client paint; true after mount (avoids SSR vs matchMedia mismatch). */
export function useHydrated(): boolean {
  const [hydrated, setHydrated] = useState(false);
  useEffect(() => {
    setHydrated(true);
  }, []);
  return hydrated;
}
